import React from "react";
import getSymbolFromCurrency from "currency-symbol-map";

const CurrencyToggleBar = ({ wallets = [], activeWalletId = null, onCurrencyChange }) => {
  if (!wallets || wallets.length === 0) {
    return null;
  }

  // Get currency symbol helper
  const getCurrencySymbol = (curr) => {
    const symbol = getSymbolFromCurrency(curr);
    if (curr === "LBP") {
      return "LL";
    }
    return symbol || "$";
  };

  return (
    <div className="currency-toggle-bar">
      {wallets.map((wallet, index) => {
        const currencyCode = wallet.currencies?.CURRENCY_CODE || wallet.CURRENCY_CODE || "USD";
        const currencySymbol = getCurrencySymbol(currencyCode);
        const walletId = wallet.ID || wallet.id;
        // First wallet (index 0) is always active, or match by ID
        const isActive = index === 0 || (activeWalletId && walletId === activeWalletId);

        return (
          <button
            key={walletId || index}
            className={`currency-toggle-item ${isActive ? "currency-toggle-item--active" : ""}`}
            onClick={() => onCurrencyChange(index)}
            type="button"
          >
            <span className="currency-toggle-symbol">{currencySymbol}</span>
            <span className="currency-toggle-code">{currencyCode}</span>
          </button>
        );
      })}
    </div>
  );
};

export default CurrencyToggleBar;

